/* Pinned to the top of the viewport while the page scrolls under it (C29).
 * Sticky rather than fixed: the bar keeps its place in the flow, so the page
 * needs no top padding that could drift from the bar's height. A sticky
 * element is also positioned, which is what the phone menu hangs from. */
.bar {
  position: sticky;
  top: 0;
  z-index: 5;
  background: var(--surface);
  border-bottom: var(--outline);
}

/* The page's scroll padding reserves the bar's strip for the bar, so the
 * browser counts the bar's own controls as hidden behind it and scrolls the
 * page when one takes focus. They are always in view: cancel the padding. */
.bar * {
  scroll-margin-top: calc(-1 * (var(--bar-height) + 16px));
}

.inner {
  display: flex;
  align-items: center;
  gap: 8px;
  height: var(--bar-height);
  max-width: calc(var(--column) + 2 * var(--gutter));
  margin: 0 auto;
  padding: 0 12px 0 var(--gutter);
}

@media (min-width: 720px) {
  .inner {
    padding: 0 var(--gutter);
  }
}
